import { createFileRoute, redirect } from "@tanstack/react-router";

// Applicants and staff share one login; the URL stays because old postings link to it.
export const Route = createFileRoute("/careers/$slug/login")({
  beforeLoad: () => {
    throw redirect({ to: "/login" });
  },
});
